import * as P from "fp-ts-routing";

export type SettingsRoute = {};

export const settingsPageMatch = P.lit("settings");
